import { KeyboardArrowDown } from "@mui/icons-material";

import AutoCompleteDropdown from "../../../../../ui library/components/dropdowns/AutoCompleteDropdown";
import HNSColors from "../../../../../ui library/HNSColors";
import { useAddresses } from "../../hooks/useAddresses";
import { useProviderSearchStore } from "../../store/providerSearchStore";
import STYLES from "../../style/style";

import CustomListBox from "./CustomListBox";

export default function AddressSearchField({ placeholder = "" }) {
  const { initAddress, addressData, addressLoading, addressShowMore, handleShowMoreAddresses } =
    useAddresses();

  const {
    setAssignedProvider,
    setAddress,
    resetCurrentPage,
    setInNetwork,
    setShowCustomSearch,
    setCustomAddressSearchText,
  } = useProviderSearchStore();

  const onValueChange = (value) => {
    setAssignedProvider(null);
    setCustomAddressSearchText("");
    setInNetwork(1);
    setAddress(value);
    setShowCustomSearch(value?.additionalDetails?.showSearch);
    resetCurrentPage();
  };

  return (
    <AutoCompleteDropdown
      data={addressData}
      initValue={initAddress}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(option, optionValue) =>
        option?.id === optionValue?.id || option === optionValue
      }
      placeholder={placeholder}
      onValueChange={(_, value) => {
        onValueChange(value);
      }}
      ListboxComponent={CustomListBox}
      ListboxProps={{
        showMore: addressShowMore,
        setShowMore: handleShowMoreAddresses,
        sx: {
          maxHeight: 200,
          overflow: "auto",
          "&::-webkit-scrollbar": { width: "6px" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: HNSColors.primary[500],
            borderRadius: "3px",
          },
        },
      }}
      textFieldSx={STYLES.textField}
      selectProps={{
        IconComponent: (props) => (
          <KeyboardArrowDown {...props} sx={{ fontSize: 24, color: HNSColors.primary[500] }} />
        ),
      }}
      dropdownSx={STYLES.selectMenuPaper}
      loading={addressLoading}
      disableClearable={true}
      size="small"
    />
  );
}
